import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { GeoJSON as GeoLeaflet } from "leaflet";
import { compose } from "recompose";
import { withSnackbar } from "notistack";

import { GeoJSON, Pane } from "react-leaflet";

import { Commune } from "../../../services";

const ZaCommune = ({ codeInsee, transmissionCoordonnees, enqueueSnackbar }) => {
  const [abortCommuneZa, setAbortCommuneZa] = useState(new AbortController());
  const [listeCommuneZa, setListeCommuneZa] = useState([]);

  const communeZaStyle = {
    color: "blue",
    weight: 2,
    opacity: 2,
    fillColor: "blue",
    dashArray: "0",
    fillOpacity: 0.1,
  };

  const displayZaCommune = () => {
    abortCommuneZa.abort();
    const abort = new AbortController();
    setAbortCommuneZa(abort);

    // Centre la carte et affiche les contours de la commmune contenant l'hexaclé
    Commune.getCommuneZa(codeInsee, abort)
      .then(async response => {
        setListeCommuneZa([
          {
            features: response.features[0],
            style: communeZaStyle,
          },
        ]);

        const target = new GeoLeaflet(response.features[0]).getBounds();
        transmissionCoordonnees(target);
      })
      .catch(e => {
        if (e.code !== "ERR_CANCELED") {
          enqueueSnackbar(process.env.ERREUR_SERVEUR, {
            variant: "error",
            autoHideDuration: 6000,
          });
        }
      });
  };

  useEffect(() => {
    if (codeInsee !== null) {
      displayZaCommune();
    }

    return () => {
      abortCommuneZa.abort();
    };
  }, [codeInsee]);

  useEffect(() => () => abortCommuneZa.abort(), []);

  return (
    <>
      <Pane name="commune" className="leaflet-commune-pane">
        {listeCommuneZa.length > 0 &&
          listeCommuneZa.map(contours => (
            <GeoJSON
              key={contours.features.properties.libelle}
              data={contours.features}
              style={contours.style}
            />
          ))}
      </Pane>
    </>
  );
};

ZaCommune.propTypes = {
  codeInsee: propTypes.string.isRequired,
  transmissionCoordonnees: propTypes.func.isRequired,
  enqueueSnackbar: propTypes.func.isRequired,
};

export default compose(withSnackbar)(ZaCommune);
